import type { Conversion } from 'generated/gql';
import { ConversionAction } from 'generated/gql';
import { uniqBy } from 'lodash';

export const filterConversionsByAction = (conversions: Conversion[], action: ConversionAction) =>
  conversions.filter((conversion) => conversion.action === action);

export const hasSingleShareType = (conversions: Conversion[] | null = []) =>
  !!conversions?.length &&
  uniqBy(filterConversionsByAction(conversions, ConversionAction.Remove), 'shareSeries.shareType')
    .length === 1;
